import {Component, Inject} from '@angular/core';
import {StructureAddress} from '@docma-mm-core/address/structure-address';
import {Structure} from '@docma-mm-core/structure/structure';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';

@Component({
  selector: 'mydocma-mm-mm-structure-addresses-dialog',
  templateUrl: './mm-structure-addresses-dialog.component.html',
  styleUrls: ['./mm-structure-addresses-dialog.component.scss']
})
export class MmStructureAddressesDialogComponent {

  currentAddresses: StructureAddress[];
  currentStructure: Structure;
  isExpanded = false;
  dialogMode = false;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: {currentAddresses: StructureAddress[], currentStructure: Structure, dialogMode: boolean}) {
    this.currentAddresses = this.dialogData.currentAddresses;
    this.currentStructure = this.dialogData.currentStructure;
    this.dialogMode = this.dialogData.dialogMode;
  }

  closeDialog() {
  }
}
